import styled from 'styled-components/macro';

export const Paragraph = styled.p`
  a {
    font-family: 'Noto Sans', sans-serif;
  }
`;
